import mixpanel from "mixpanel-browser";
import "./App.css";
import "./fonts.css";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
// import { LandingPageRoute } from "./components/LandingPageRoute/LandingPageRoute";
import { LandingPageRoute } from "./components/LandingPageRevamp";
import TermsAndConditionRoute from "./components/TermsAndCondition/TermsAndConditionRoute/TermsAndConditionRoute";
import RefundPolicyRoute from "./components/RefundPolicy/RefundPolicyRoute.js/RefundPolicyRoute";
import { Login } from "./components/LoginFlow/Login/Login";
import { SignUp } from "./components/LoginFlow/SignUp/SignUp";
import { ForgotPassword } from "./components/LoginFlow/ForgotPassword/ForgotPassword";
import LoginFlow from "./components/LoginFlow/LoginFlow";
import { SignUpWithGoogle } from "./components/LoginFlow/GoogleLogin/GoogleLoginScreen";
import ScrollToTop from "./ScrollToTop";
import Stories from "./components/Stories/Stories";
import { StoriesContextProvider } from "./Contexts/StoriesContexts";
import { useGlobalContext } from "./Contexts/GlobalContext";
import { StartFreeTrial } from "./components/StartFreeTrial/StartFreeTrial";
import { mixpanelToken } from "./mixpanelConstant";
import { useEffect, useState } from "react";
import Cookies from "universal-cookie";
import { isNULLEMPTYORUNDEFINED } from "./Utilities/SessionUtility";
import { SubscriptionContextProvider } from "./components/LandingPage/Pricing/SubscriptionContext";
import { PricingContextProvider } from "./Contexts/PricingContext";
import SubscriptionRenewal from "./components/LandingPage/Pricing/SubscriptionRenewal";
import CourseSelectionScreen from "./courses/SelectionScreen/CourseSelectionScreen";
import LowLevelDesignLandingPage from "./components/LowLevelDesignLandingPage/LowLevelDesignLandingPage";
import WelcomeScreenFreeTrial from "./components/WelcomeScreen/WelcomeScreenFreeTrial";
import CppLandingPageRoute from "./components/CppLandingPage/CppLandingPageRoute";
import ReactLandingPageRoute from "./components/ReactLandingPage/ReactLandingPageRoute";
import DsaCrashCourseRoute from "./components/DsaCrashCourse/DsaCrashCourseRoute";
import PythonLandingPageRoute from "./components/PythonLandingPage/PythonLandingPageRoute";
import SpringBootLandingPage from "./components/SpringBootLandingPage/SpringBootLandingPage";
import WhatsappContactUs from "./components/Common/WhatsappContactUs";
import { COURSE_NAME_TO_COURSE_URL_MAPPING } from "./Constants/ReRoutingConstants";
mixpanel.init(mixpanelToken, { ignore_dnt: true });

function App() {
    const cookies = new Cookies();
    const [loaded, setLoaded] = useState(false);
    const { checkSubscribed } = useGlobalContext();
    const [couponCode, setCouponCode] = useState("");

    useEffect(() => {
        // initializeGTM();
        getAuthCookie();
    }, []);

    const getAuthCookie = async () => {
        try {
            if (!isNULLEMPTYORUNDEFINED(cookies.get("authorization"))) await checkSubscribed();
        } catch (err) {
            console.error("Error fetching subscription data : " + err);
        } finally {
            setLoaded(true);
        }
    };

    return !loaded ? (
        <></>
    ) : (
        <div className="App Success-Stories-App">
            <>
                <ScrollToTop />
                <WhatsappContactUs />
                <Routes>
                    <Route
                        exact
                        path={COURSE_NAME_TO_COURSE_URL_MAPPING.RENAISSANCE}
                        element={
                            <SubscriptionContextProvider>
                                <LandingPageRoute
                                    couponCode={couponCode}
                                    setCouponCode={setCouponCode}
                                />
                            </SubscriptionContextProvider>
                        }
                    />

                    <Route
                        exact
                        path={COURSE_NAME_TO_COURSE_URL_MAPPING.LOW_LEVEL_DESIGN}
                        element={
                            <PricingContextProvider>
                                <LowLevelDesignLandingPage
                                    couponCode={couponCode}
                                    setCouponCode={setCouponCode}
                                />
                            </PricingContextProvider>
                        }
                    />

                    <Route
                        exact
                        path="/terms-and-conditions"
                        element={<TermsAndConditionRoute setCouponCode={setCouponCode} />}
                    />
                    <Route exact path="/refund-policy" element={<RefundPolicyRoute />} />
                    <Route
                        exact
                        path={`${COURSE_NAME_TO_COURSE_URL_MAPPING.RENAISSANCE}/stories`}
                        element={
                            <StoriesContextProvider>
                                <Stories />
                            </StoriesContextProvider>
                        }
                    />
                    <Route
                        exact
                        path="/stories"
                        element={<Navigate to="/crack-coding-interviews/stories" replace />}
                    />
                    <Route path="*" element={<Navigate to="/crack-coding-interviews" replace />} />
                    <Route exact path="/" element={<LoginFlow />} />
                    <Route path="/login" element={<Login setCouponCode={setCouponCode} />} />
                    <Route path="/signup" element={<SignUp setCouponCode={setCouponCode} />} />
                    <Route
                        path="/forgot-password"
                        element={<ForgotPassword setCouponCode={setCouponCode} />}
                    />
                    <Route path="/signup-with-google" element={<SignUpWithGoogle />} />
                    <Route path="/start-free-trial" element={<StartFreeTrial />} />

                    <Route
                        exact
                        path={COURSE_NAME_TO_COURSE_URL_MAPPING.DSA_ESSENTIALS}
                        element={
                            <PricingContextProvider>
                                <DsaCrashCourseRoute
                                    couponCode={couponCode}
                                    setCouponCode={setCouponCode}
                                />
                            </PricingContextProvider>
                        }
                    />
                    {/* <Route
                        exact
                        path={COURSE_NAME_TO_COURSE_URL_MAPPING.FULL_STACK_DEVELOPMENT}
                        element={
                            <PricingContextProvider>
                                <ReactLandingPageRoute
                                    couponCode={couponCode}
                                    setCouponCode={setCouponCode}
                                />
                            </PricingContextProvider>
                        }
                    /> */}
                    <Route
                        exact
                        path={COURSE_NAME_TO_COURSE_URL_MAPPING.BEGIN_WITH_CPP}
                        element={
                            <PricingContextProvider>
                                <CppLandingPageRoute
                                    couponCode={couponCode}
                                    setCouponCode={setCouponCode}
                                />
                            </PricingContextProvider>
                        }
                    />

                    <Route
                        exact
                        path={COURSE_NAME_TO_COURSE_URL_MAPPING.BEGIN_WITH_PYTHON}
                        element={
                            <PricingContextProvider>
                                <PythonLandingPageRoute
                                    couponCode={couponCode}
                                    setCouponCode={setCouponCode}
                                />
                            </PricingContextProvider>
                        }
                    />

                    <Route exact path="/course-select" element={<CourseSelectionScreen />} />

                    <Route
                        exact
                        path={COURSE_NAME_TO_COURSE_URL_MAPPING.JAVA_SPRING_BOOT}
                        element={
                            <PricingContextProvider>
                                <SpringBootLandingPage
                                    couponCode={couponCode}
                                    setCouponCode={setCouponCode}
                                />
                            </PricingContextProvider>
                        }
                    />
                </Routes>
            </>
        </div>
    );
}

export default App;
